export default __webpack_public_path__ + "sounds/fa606eb915ffe09b6bdcf82496b7d5f3.mp3";